import React, { Component } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Grid,
  Card,
  CardContent,
  Typography,
  MenuItem, Checkbox, Select,
} from '@material-ui/core';
import {
  CloseOutlined as CloseIcon, LocalFlorist,
} from '@material-ui/icons';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MyPATDialog, MyPATIconButton, MyPATTextField, MyPATTextArea, MyPATSelect } from '../../common';
import { rolesEnum } from '../types/RolesEnumBody';
import { UserRoleBody } from '../types/UserRolesBody';
import { UserRoleList, deleteRole, getRolesCount, addRole } from '../actions/userRoleAction';
import { UserRoleService } from '../services/userRoleServices';

const styles = (theme: Theme) => createStyles({
  mb1x: {
    marginBottom: theme.spacing.unit,
  },
  mb2x: {
    marginBottom: theme.spacing.unit * 2,
  },
  fwNormal: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  cardContentRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    '&:last-child': {
      paddingBottom: theme.spacing.unit * 2,
    },
  },
  textRight: {
    textAlign: 'right',
  },
  selectDropDown: {
    paddingTop: theme.spacing.unit * 3
  },
  checkBoxFeature: {
    padding: "0px",
  },
  checkBoxText: {
    fontSize: "0.68em",
  },
  selectBoxGrid: {
    '& > div': {
      width: '100%',
      '& > div > div > div': {
        fontSize: '0.8rem',
      }
    }
  },
  featureLabel: {
    textAlign: 'right',
    fontWeight: theme.typography.fontWeightRegular,
  },
});

interface CreateRoleDialogProps extends WithStyles<typeof styles> {
  dialogOpen: boolean,
  dialogCloseHandler: Function,
  enumRoles: rolesEnum,
  updateRole: UserRoleBody,
  getRolesCount: () => void,
  UserRoleList: () => void,
  addRole: (role: UserRoleBody) => void,
}

interface CreateRoleDialogState {
  permission: any,
  formData: UserRoleBody,
  dialogName: string,
  errName: string,
  validAccess: any,
  allAccess: any,
}

class CreateRoleDialog extends Component<CreateRoleDialogProps, CreateRoleDialogState> {
  updateRoleEventTimer: any = 0;
  constructor(props: CreateRoleDialogProps) {
    super(props);
    this.state = {
      permission: {
        CONTENT: ["CREATE", "UPDATE", "DELETE", "SHARE", "VIEW", "EDIT", "VALIDATE"],
        CONTENTSETTING: ["NONE"],
        COURSE: ["CREATE", "UPDATE", "DELETE", "SHARE", "VIEW", "VALIDATE"],
        PACKAGE: ["NONE"],
        RULE: ["CREATE", "UPDATE", "DELETE", "SHARE", "VIEW", "VALIDATE"],
        TAG: ["CREATE", "UPDATE", "DELETE", "SHARE", "VIEW", "VALIDATE"],
        USER: ["NONE"],
      },
      formData: {},
      dialogName: "",
      errName: "",
      validAccess: {
        'Content': ['CREATE', 'PUBLISH']
      },
      allAccess: ['CONTENT', 'PACKAGE', 'USER', 'CONTENTSETTING', 'COURSE', 'TAG', 'RULE'],

    };

    this.handleDialogSave = this.handleDialogSave.bind(this);
    this.addPermission = this.addPermission.bind(this);
  }

  handleDialogSave = () => {
    let { formData, permission, errName }: any = this.state;


    if (formData.role && formData.role.trim() != "") {
      if (permission) {
        formData.featureLevelPermissions = [];
        Object.keys(permission).forEach(p => {
          formData.featureLevelPermissions.push({ featureType: p, accessAllowed: permission[p] });
        });

        if (!formData._id) {
          UserRoleService.saveRole(formData)
            .then((res: any) => {
              this.setState({ formData: {} })
              this.props.addRole(res);
              this.props.dialogCloseHandler();
            });
        } else {
          UserRoleService.updateRole(formData)
            .then((res: any) => {
              this.setState({ formData: {} });
              this.props.dialogCloseHandler();
            });
        }
      }
    }
    else {
      errName = 'Required *';
      this.setState({ errName });
      return false;
    }

  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps: any) {
    this.updateRoleEventTimer = setTimeout(this.updateRoleEvent.bind(this), 700);
  }

  componentWillUnmount() {
    clearTimeout(this.updateRoleEventTimer);
  }
  updateRoleEvent() {
    let { updateRole, enumRoles } = this.props;
    let { permission, validAccess, allAccess, formData } = this.state;


    if (enumRoles) {
      if (!updateRole && enumRoles && allAccess && allAccess.length > 0) {
        _.map(allAccess, allAccess => {
          if (!permission[allAccess]) {
            permission[allAccess] = [];
          }
        });
        formData = {};
        this.setState({ formData });
      }
      else if (updateRole && updateRole._id) {
        if (!_.isUndefined(updateRole)) {
          _.map(updateRole.featureLevelPermissions, (per) => {
            permission[per.featureType] = per.accessAllowed;
          })
          this.setState({ permission: permission, formData: updateRole, dialogName: "Update Role" });
        }
      }

    }
  }


  addPermission(e: any) {
    let { name, value } = e.target;
    let { permission } = this.state;

    if (!permission[name])
      permission[name] = [];

    permission[name] = value.split(",");
    this.setState({ permission });


  }

  handleChangeEvent(e: any) {
    let { name, value } = e.target;
    let formData: any = this.state.formData;
    let { errName } = this.state;

    if (name == 'role') {
      errName = !value ? 'Required *' : ''
    }

    formData[name] = value;
    this.setState({ formData: formData, errName: errName });
  }

  render() {
    const {
      classes,
      dialogOpen,
      dialogCloseHandler,
      enumRoles
    } = this.props;

    const {
      permission,
      formData,
      dialogName,
      errName,
      allAccess,
      validAccess,

    } = this.state;

    const otherDialogProps = {
      fullWidth: true,
      maxWidth: 'md',
      scroll: 'body',
    };




    return (

      <MyPATDialog
        dialogOpen={dialogOpen}
        otherDialogProps={otherDialogProps}
        onDialogSave={this.handleDialogSave.bind(this)}
        customDialogTitle={
          <Grid container justify="space-between" alignItems="center">
            <Grid item xs>
              <Typography variant="h6"> {_.isEmpty(dialogName) ? 'Create Role' : dialogName} </Typography>
            </Grid>

            <Grid item xs="auto" className={classes.textRight}>
              <MyPATIconButton buttonVariant="flat" onClick={dialogCloseHandler}>
                <CloseIcon />
              </MyPATIconButton>
            </Grid>
          </Grid>
        }
      >
        <Card className={classes.mb1x}>
          <CardContent className={classes.cardContentRoot}>
            <Grid container alignItems="center">
              <Grid item xs={12} className={classes.mb1x}>
                <Typography variant="h6" className={classes.fwNormal}>Basic Info</Typography>
              </Grid>

              <Grid item xs={12} className={classes.mb1x}>
                <Typography variant="body1" gutterBottom>Role Name</Typography>
                <MyPATTextField
                  inputId="roleName"
                  name="role"
                  error={errName != "" ? true : false}
                  errorText={errName}
                  placeholder="Enter Name"
                  value={formData.role || ''}
                  onChange={this.handleChangeEvent.bind(this)}
                  fullWidthControl
                />
              </Grid>

              <Grid item xs={12} className={classes.mb1x}>
                <Typography variant="body1" gutterBottom>Descriptions</Typography>
                <MyPATTextArea
                  inputId="decription"
                  name="description"
                  placeholder="Write here..."
                  rows="3"
                  value={formData.description || ''}
                  onChange={this.handleChangeEvent.bind(this)}
                  multiline
                  fullWidthControl
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card className={classes.mb1x}>
          <CardContent className={classes.cardContentRoot}>
            <Grid container alignItems="center" spacing={16} justify="center">
              <Grid item xs={12} className={classes.mb1x}>
                <Typography variant="h6" className={classes.fwNormal}>Permissions</Typography>
              </Grid>

              <Grid item sm={12}>
                <Grid container alignItems="center" justify="space-between" spacing={16} className={classes.mb1x}>
                  {_.map(enumRoles.featureTypes, (featurePermission, i) => (
                    <Grid key={`${featurePermission}_${i}`} item sm={6}>
                      <Grid container alignItems="center" spacing={8}>
                        <Grid item xs={5}>
                          <Typography variant="body1" className={classes.featureLabel}>
                            {!_.isEmpty(enumRoles.featureName) && !_.isUndefined(enumRoles.featureName[featurePermission]) ? `${enumRoles.featureName[featurePermission]}:` : ''}
                          </Typography>
                        </Grid>
                        <Grid item xs={7} className={classes.selectBoxGrid}>
                          <MyPATSelect
                            inputId={featurePermission}
                            value={permission[featurePermission].join(",")}
                            name={featurePermission}
                            onChange={this.addPermission}

                          >
                            {
                              _.map(enumRoles.validAccessTypes[featurePermission], (currentData: any, i: number) => (
                                <option key={`enumroles_${i}`} value={currentData.split(':')[1]} >{currentData.split(':')[0]}</option>
                              ))
                            }
                          </MyPATSelect>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MyPATDialog>
    );
  }
}
const mapStateToProps = (state: any) => ({
  enumRoles: _.get(state, 'userManagement.userRoleList.enumList', [])
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    UserRoleList,
    getRolesCount,
    addRole,
  },
  dispatch
);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreateRoleDialog));